<template>
    <div>
        <div v-for="lector in templateArgs.lectors">
            <p>{{lector.fullName}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'annualCatalogLectorsTemplate',
        data() {
            return {
                templateArgs: {}
            };
        },
    }
</script>

<style scoped>

</style>
